import type { AvatarEquipment } from './kaykitEquipment'

/** Внешность аватара — заложено под будущие скины / одежду / лицо. */
export interface AvatarFace {
  eyeStyle: 'dot' | 'big' | 'wink' | 'anime'
  mouthStyle: 'smile' | 'grin' | 'o' | 'flat'
  blush: boolean
  browStyle: 'none' | 'angry' | 'unibrow'
}

export interface AvatarClothes {
  topColor: string
  bottomColor: string
  sleeveStyle: 'short' | 'long' | 'tank'
  hat: 'none' | 'cap' | 'beanie' | 'propeller' | 'crown'
  accessory: 'none' | 'backpack' | 'scarf' | 'glasses'
}

export interface AvatarAppearance {
  /** KayKit / Quaternius character id */
  characterId?: string
  /** Kenney texture skin (optional for legacy payloads) */
  baseSkin?: 'survivorMaleB' | 'survivorFemaleA' | 'zombieA' | 'zombieC'
  tint?: string
  skinTone: string
  hairColor: string
  hairStyle: 'short' | 'spiky' | 'afro' | 'pony' | 'bald' | 'mohawk'
  /** 0.85–1.2 — худощавый…пышный */
  bodyScale: number
  face: AvatarFace
  clothes: AvatarClothes
  equipment?: AvatarEquipment
}

export interface CrowdAvatar {
  id: string
  displayName: string
  appearance: AvatarAppearance
}

export type CrowdActionType =
  | 'throw_poop'
  | 'throw_grenade'
  | 'throw_heart'
  | 'smash_glass'

export interface CrowdActionEvent {
  id: string
  avatarId: string
  displayName?: string
  action: CrowdActionType
  message?: string
  timestamp: number
  appearance?: AvatarAppearance
}

export const CROWD_AVATARS_EVENT_TYPE = 'crowd_avatars' as const
